import React ,{Fragment} from "react";
import {BiCaretDown} from "react-icons/bi";
import TruncateMarkup from "react-truncate";

const ResultCard = (props)=>{
    const {link,  displayLink, title, snippet} = props;
    return(
        <Fragment>
            <div id="mainResultCard" className="result_card_container flex-column">
                <a href={link}>
                    <span>{displayLink} <BiCaretDown/></span>
                    <h5><TruncateMarkup line={1} ellipsis="..">{title}</TruncateMarkup></h5>
                </a>
                    
                <p><TruncateMarkup line={4} ellipsis="...">{snippet}</TruncateMarkup></p>
               
            </div>
        </Fragment>
    )
}
export default ResultCard;